import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { meetingTopicPath, meetingTypePath, } from "../../src/View/Pages/MeetingRequest/MeetingRequestRoutes";
export default class MeetingTeam extends Component {
    // @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
    constructor(props) {
        super(props);
        // @ts-expect-error - TS2339 - Property 'virtualizedApp' does not exist on type 'MeetingTeam'.
        this.virtualizedApp = props.virtualizedApp;
        this.renderMeetingTeam = this.renderMeetingTeam.bind(this);
    }
    selectMeetingTeam(team) {
        // this.props.meetingTeams.forEach((mt) => { mt.isSelected = false; });
        this.props.selectMeetingTeam(team);
    }
    renderMeetingTeam(team) {
        return (_jsx("div", { className: "col-md-4 col-sm-6 my-1", children: _jsxs("button", { className: "btn btn-lg " +
                    (team.isSelected ? "btn-success" : "btn-outline-dark"), style: { width: "100%", whiteSpace: "normal" }, onClick: () => this.selectMeetingTeam(team), children: [_jsxs("div", { children: [team.isSelected ? (_jsx("span", { className: "fa fa-check mr-1", "aria-hidden": "true" })) : (""), team.name] }), _jsx("div", { children: _jsxs("small", { children: [_jsx("span", { className: "fas fa-map-marker-alt", "aria-hidden": "true" }), " ", team.location.name] }) })] }) }, team.id));
    }
    renderNextButton() {
        const teamSelected = this.props.meetingTeams.some((team) => team.isSelected);
        if (teamSelected) {
            return (_jsxs(Link, { to: {
                    pathname: meetingTypePath({}),
                    search: this.props.pageParams,
                }, className: "btn btn-primary btn-lg", children: ["Next ", _jsx("span", { className: "fa fa-chevron-right", "aria-hidden": "true" })] }));
        }
        return (
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'boolean | undefined'.
        _jsxs("button", { className: "btn btn-primary btn-lg", disabled: "true", children: ["Next ", _jsx("span", { className: "fa fa-chevron-right", "aria-hidden": "true" })] }));
    }
    render() {
        return (_jsxs("div", { children: [_jsxs("div", { className: "my-3", children: [_jsxs("h2", { children: [this.props.isThirdPartyScheduler ? "Student needs " : "I want ", "to meet with someone from..."] }), _jsx("div", { className: "row", children: this.props.meetingTeams &&
                                this.props.meetingTeams.map(this.renderMeetingTeam) })] }), _jsxs("div", { className: "mb-3 d-flex justify-content-between", children: [_jsxs(Link, { to: {
                                pathname: meetingTopicPath({}),
                                search: this.props.pageParams,
                            }, className: "btn btn-outline-dark btn-lg", children: [_jsx("span", { className: "fa fa-chevron-left", "aria-hidden": "true" }), " Previous"] }), this.renderNextButton()] })] }));
    }
}
